import { ColumnDef } from "@tanstack/react-table";
import DataTableColumnHeader from "../components/data-table/data-table-column-header";
import React from "react";
import { format } from "date-fns";
import { Backup } from "../Central/Admin/Backups";

const columns: ColumnDef<Backup>[] = [
    {
        accessorKey: "type",
        header: ({ column }) => {
            return <DataTableColumnHeader column={column} title="Type" type="filter" />;
        },
        filterFn: (row, id, value) => value.includes(row.getValue(id)),
        meta: {
            title: "Type",
        },
    },
    {
        accessorKey: "started_at",
        header: ({ column }) => {
            return (
                <DataTableColumnHeader
                    column={column}
                    title="Started At (CEST)"
                    type="date-range"
                />
            );
        },
        filterFn: (row, id, value) =>
            new Date(row.getValue(id)) > new Date(value.from) &&
            new Date(row.getValue(id)) < new Date(value.to),
        meta: {
            title: "Started At (CEST)",
        },
        cell: ({ row }) => {
            const value = row.getValue("started_at") as string;
            return <span>{format(new Date(value), "PPP")}</span>;
        },
    },
    {
        accessorKey: "completed_at",
        header: ({ column }) => {
            return <DataTableColumnHeader column={column} title="Completed at" type="filter" />;
        },
        filterFn: (row, id, value) => value.includes(row.getValue(id)),
        meta: {
            title: "Completed at",
        },
    },
    {
        accessorKey: "status",
        header: ({ column }) => {
            return <DataTableColumnHeader column={column} title="Company name" type="filter" />;
        },
        filterFn: (row, id, value) => value.includes(row.getValue(id)),
        meta: {
            title: "Status",
        },
    },
];

export { columns };
